module.exports = __webpack_public_path__ + "img/1.6193f119.png";